import { Chip } from '@mui/material';

export const IsDelivered = (
<Chip sx={{ marginBottom: 1.5 }} 
        source="delivered"
        label="Delivered"
        defaultValue={"-"} 
/>
)
